export const REDUX_STORE_HOME = 'add_newsletter_content_source'
export const SOURCE_NAME = 'Newsletter Content'
